import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  EVENTS_ERROR,
  EVENTS_REQUEST,
  EVENTS_RESET,
  EVENTS_SUCCESS,
} from "./ActionType";

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId ?? "");
  requestSequence += 1;
  return {
    shopId: normalizedShopId,
    requestId: `events:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }

  if (typeof response.json === "function") return response.json();
  return null;
};

const errorMessage = (payload, response) =>
  [payload?.message, payload?.error, payload?.detail].find(
    (value) => typeof value === "string" && value.trim()
  ) || `Events request failed (${response.status})`;

export const eventApi = ({
  storeId,
  pageNumber,
  pageSize,
  page,
  pageLength,
}) => async (dispatch) => {
  const meta = createRequestMeta(storeId);
  const requestedPage = Number.isSafeInteger(pageNumber)
    ? pageNumber
    : Number.isSafeInteger(page)
    ? page
    : 0;
  const requestedPageSize = Number.isSafeInteger(pageSize)
    ? pageSize
    : Number.isSafeInteger(pageLength)
    ? pageLength
    : 10;
  dispatch({ type: EVENTS_REQUEST, meta });

  try {
    const response = await authenticatedFetch(
      `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.events}`,
      {
        method: "POST",
        body: JSON.stringify({
          pageNumber: requestedPage,
          pageSize: requestedPageSize,
          storeId,
        }),
        credentials: "include",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      }
    );
    const data = await readResponsePayload(response);
    if (!response.ok) throw new Error(errorMessage(data, response));

    dispatch({ type: EVENTS_SUCCESS, payload: data, meta });
    return { ok: true, payload: data };
  } catch (error) {
    const message = error?.message || "Events request failed";
    dispatch({ type: EVENTS_ERROR, payload: message, meta });
    return { ok: false, error: message };
  }
};

export const resetEvents = (shopId) => ({
  type: EVENTS_RESET,
  meta: shopId === undefined ? undefined : { shopId: String(shopId) },
});
